import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { cloneElement, Component } from 'react';
import classNames from 'classnames';
import Measure from 'react-measure';
import { CLS_PREFIX } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `Grid` component is used to layout and align content based on 12-column system.
 * @since 0.0.48
 */
class Grid extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      xs: this.props.xs
    });
    _defineProperty(this, "handleResize", _ref => {
      let {
        bounds
      } = _ref;
      const {
        width
      } = bounds;
      let {
        maxColumnsNumber
      } = this.props;
      if (typeof maxColumnsNumber === 'function') {
        maxColumnsNumber = maxColumnsNumber({
          width
        });
      }
      const xs = Math.max(Math.floor((width + this.getGapSize()) / (this.props.minColumnWidth + this.getGapSize())), 1);
      this.setState({
        xs: Math.min(xs, maxColumnsNumber)
      });
      if (this.props.onColumnsChange) {
        this.props.onColumnsChange(xs);
      }
    });
  }
  getGapSize() {
    switch (this.props.gap) {
      case 'xs':
        return 8;
      case 'sm':
        return 12;
      case 'md':
        return 16;
      case 'lg':
        return 24;
      case 'xl':
        return 32;
      default:
        return 0;
    }
  }
  render() {
    const {
      baseClassName,
      className,
      minColumnWidth,
      onColumnsChange,
      maxColumnsNumber,
      xs,
      sm,
      md,
      lg,
      xl,
      gap,
      children,
      ...props
    } = this.props;
    const computedClassName = classNames(baseClassName, {
      [`${baseClassName}--xs-${this.state.xs}`]: this.state.xs,
      [`${baseClassName}--sm-${sm}`]: sm,
      [`${baseClassName}--md-${md}`]: md,
      [`${baseClassName}--lg-${lg}`]: lg,
      [`${baseClassName}--xl-${xl}`]: xl,
      [`${baseClassName}--gap-xs`]: gap === 'xs',
      [`${baseClassName}--gap-sm`]: gap === 'sm',
      [`${baseClassName}--gap-md`]: gap === 'md',
      [`${baseClassName}--gap-lg`]: gap === 'lg',
      [`${baseClassName}--gap-xl`]: gap === 'xl'
    }, className);
    const result = /*#__PURE__*/_jsx("div", {
      className: computedClassName,
      ...props,
      children: minColumnWidth && !this.state.xs ? null : children
    });
    if (minColumnWidth) {
      return /*#__PURE__*/_jsx(Measure, {
        bounds: true,
        onResize: this.handleResize,
        children: _ref2 => {
          let {
            measureRef
          } = _ref2;
          return /*#__PURE__*/cloneElement(result, {
            ref: measureRef
          });
        }
      });
    }
    return result;
  }
}
_defineProperty(Grid, "defaultProps", {
  children: null,
  className: null,
  baseClassName: `${CLS_PREFIX}grid`,
  minColumnWidth: null,
  maxColumnsNumber: 6,
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xl: null,
  gap: null,
  onColumnsChange: null
});
export default Grid;